<section id="alert" class="alert-overlay" [class.active]="active">
  <div class="alert">
    <p class="alert-message">{{ message }}</p>
    <button type="button" class="btn btn-primary" id="alert-btn" (click)="close()">Ok</button>
  </div>
</section>
